import type { BufferEditor } from '~publish/legacy/editor/BufferEditor/types.plate'

import { generateText } from './commands/generateText'
import { getGeneratedContent } from './commands/getGeneratedContent'
import { getPrompt } from './commands/getPrompt'
import type { TPrompt } from './commands/getPrompt'
import { removeGeneratedContent } from './commands/removeGeneratedContent'
import { unwrapGeneratedContent } from './commands/unwrapGeneratedContent'

type TGenerateTextParams = {
  organizationId: string
  action: string
  service?: string
  annotation: string | null
  previousGeneration?: string
  metadata: {
    placement: string
    retry: boolean
  }
}

/**
 *
 */
export const withGeneratedContent = (editor: BufferEditor): BufferEditor => {
  editor.generateText = ({
    organizationId,
    action,
    service,
    annotation,
    metadata,
  }: TGenerateTextParams): Promise<void> =>
    generateText({
      editor,
      organizationId,
      action,
      service,
      annotation,
      metadata,
    })

  editor.prompt = (): TPrompt => getPrompt({ editor })

  editor.getGeneratedContent = (): string | null =>
    getGeneratedContent({ editor })
  editor.keepGeneratedContent = (): void => unwrapGeneratedContent({ editor })
  editor.removeGeneratedContent = (): void => removeGeneratedContent({ editor })

  editor.highlighted = null
  editor.hasGeneratedContent = false

  return editor
}

export { TGenerateTextParams }
